<template>
    <div>
        <form ref="form" @submit.prevent="saveContent" class="">
            <div class="w-full">
                <vx-select
                    label="Content Type"
                    name="Content Type"
                    :rules="['required']"
                    placeholder="Choose the Content Type"
                    class="w-full"
                    v-model="details.contentType"
                    :options="contentTypes"
                    valueKey="id"
                    textKey="type"
                    :disabled="details.id"
                >
                </vx-select>

                <vx-input
                    label="Name"
                    name="Name"
                    :rules="['required']"
                    v-model="details.name"
                    class="w-full"
                    placeholder="Enter the name"
                />
                <vx-textarea
                    label="Description"
                    name="Description"
                    :rules="['required']"
                    v-model="details.description"
                    rows="3"
                    class="w-full -mt-1"
                ></vx-textarea>

                <vx-select
                    label="Genre"
                    name="Genre"
                    :rules="['required']"
                    placeholder="Choose Genre"
                    class="w-full"
                    v-model="details.genre"
                    :options="genres"
                    idKey="id"
                    textKey="name"
                    @selected="selectedInterests = []"
                >
                </vx-select>

                <label>Interests</label>
                <div class="flex vs-row">
                    <div
                        class="w-1/4 my-4 text-center"
                        v-for="interest in interests"
                        :key="interest.id"
                    >
                        <vx-checkbox
                            :disabled="availableInterests.all((x) => x.id != interest.id)"
                            v-model="selectedInterests"
                            :vs-value="interest.id"
                            :label="interest.name"
                        >
                        </vx-checkbox>
                    </div>
                </div>
                <vx-output
                    v-if="details.genre"
                    class="vs-input--label"
                    style-label-override="color: rgba(0,0,0,0.6)"
                    :label="`Occupied Menu List Number for ${details.genre.name}`"
                    readonly
                    :value="menuListNumbers.join(', ')"
                />

                <vx-input
                    label="Menu List Number"
                    name="Menu List Number"
                    :rules="[
                        'required',
                        (v) =>
                            (v && v > 0 && /^[0-9]{1,10}$/.test(v)) ||
                            'Must be a whole number greater than 0'
                    ]"
                    type="number"
                    v-model.number="details.sortOrder"
                    class="w-full"
                    placeholder="Enter Menu List Number"
                />

                <div class="flex vs-row justify-between">
                    <div>
                        <label class="vs-select--label">Lock / Unlock Content?</label>
                        <vs-switch class="mb-4" v-model="details.isLocked">
                            <span slot="on">Locked</span>
                            <span slot="off">Unlocked</span>
                        </vs-switch>
                    </div>

                    <div>
                        <label class="vs-select--label"
                            >Allow Preview when Authenticated (not a paying user)</label
                        >
                        <vs-switch class="mb-4" v-model="details.isPreview">
                            <span slot="on">Yes (Allow Preview)</span>
                            <span slot="off">No</span>
                        </vs-switch>
                    </div>
                </div>
                <vx-select
                    label="Locked by Coupon"
                    name="Coupon"
                    placeholder="Choose a Coupon"
                    class="w-full"
                    v-model="details.lockedByCoupon"
                    :options="coupons"
                    idKey="id"
                    :textKey="(c) => `${c.code} - ${c.description}`"
                >
                </vx-select>

                <label class="vs-select--label">Visible on Homepage?</label>
                <vs-switch class="mb-4" v-model="details.displayOnHomeScreen">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                </vs-switch>

                <vx-resource-set
                    v-if="details.displayOnHomeScreen"
                    :resources="homePageImage"
                    allow-create
                    allow-delete
                    :limit="1"
                    read-only
                    justify="center"
                    text="Upload Homepage Image for Content"
                    class="mr-2 imageUploaderText"
                    @uploaded="setHomePageImage"
                >
                </vx-resource-set>

                <div>
                    <label class="vs-select--label"> Meditation Experience Level </label>
                    <vs-slider
                        text-fixed="%"
                        v-model="details.experienceRequired"
                        onclick="return false;"
                    />
                    <div id="beginner">Beginner</div>
                    <div id="intermediate">Intermediate</div>
                    <div id="advanced">Advanced</div>
                </div>

                <div class="py-5 twoColumnSplit">
                    <label class="vs-select--label">Intended Audience</label>
                    <div v-for="(group, index) in audienceGroups" :key="index">
                        <vx-checkbox
                            v-model="details.intendedAudiences"
                            :vs-value="group.id"
                            class="py-2 vs-select--label"
                        >
                            {{ group.ageRange }}
                        </vx-checkbox>
                    </div>
                </div>

                <div class="py-5 twoColumnSplit">
                    <label class="vs-select--label">Restricted Audience</label>
                    <div v-for="(group, index) in audienceGroups" :key="index">
                        <vx-checkbox
                            v-model="details.restrictedToAudiences"
                            :vs-value="group.id"
                            class="py-2 vs-select--label"
                        >
                            {{ group.ageRange }}
                        </vx-checkbox>
                    </div>
                </div>

                <vx-calendar-input
                    label="Publishing Date"
                    name="Publishing Date"
                    :rules="['required']"
                    class="w-full"
                    v-model="details.dateToPublishLive"
                ></vx-calendar-input>

                <!-- <vx-input
                    label="Tags (optional)"
                    name="Tags"
                    v-model="details.tags"
                    class="w-full"
                    placeholder="Enter a tag, e.g. #focus"
                /> -->

                <!-- <vx-input
                    label="Entitlement (optional)"
                    name="Entitlement"
                    v-model="details.entitlement"
                    class="w-full"
                    placeholder="Enter an entitlement coupon"
                /> -->

                <vx-textarea
                    label="Additional Notes"
                    v-model="details.notes[0].text"
                    rows="3"
                    class="w-full -mt-1"
                ></vx-textarea>

                <div class="flex justify-between">
                    <vx-resource-set
                        :resources="contentPageImage"
                        allow-create
                        allow-delete
                        :limit="1"
                        read-only
                        justify="center"
                        text="Upload Content Image"
                        class="mr-2 imageUploaderText"
                        @uploaded="setContentPageImage"
                    >
                    </vx-resource-set>

                    <vx-resource-set
                        :resources="menuImage"
                        allow-create
                        allow-delete
                        :limit="1"
                        read-only
                        justify="center"
                        text="Upload Menu Image"
                        class="mr-2 imageUploaderText"
                        @uploaded="setMenuImage"
                    >
                    </vx-resource-set>
                </div>

                <div class="flex justify-center mt-10 relative">
                    <vs-button button="submit" color="success" type="gradient" icon="save">
                        {{ details.id ? 'Save Content' : 'Create Content' }}
                    </vs-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'content-metadata',
    components: {},
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    watch: {
        'value': {
            handler(val) {
                this.details = this.deepCopy(val)
                this.details.interests.forEach((i) => {
                    this.selectedInterests.push(i.id)
                })
                if (this.details.contentPageImage) {
                    this.setContentPageImage(this.details.contentPageImage)
                }
                if (this.details.homePageImage) {
                    this.setHomePageImage(this.details.homePageImage)
                }
                if (this.details.menuImage) {
                    this.setMenuImage(this.details.menuImage)
                }
            },
            immediate: true
        },
        'details.genre': {
            handler(val, oldVal) {
                if (oldVal == null || val.id != oldVal.id) {
                    this.fetchGenreListNumbers()
                }
            }
        }
    },
    data() {
        return {
            audienceGroups: [
                { id: 1, ageRange: 'Less than 5 y/o' },
                { id: 2, ageRange: '6 - 11 y/o' },
                { id: 3, ageRange: '11 - 18 y/o' },
                { id: 4, ageRange: '18 - 55 y/o' },
                { id: 5, ageRange: '55 y/o +' }
            ],
            contentTypes: [
                { id: 1, type: 'Single' },
                { id: 2, type: 'Playlist' }
            ],
            interests: [],
            details: {
                notes: [{ text: '' }],
                intendedAudiences: [],
                restrictedToAudiences: [],
                name: null,
                description: null,
                contentType: 1,
                entitlement: null,
                experienceRequired: 50,
                genre: null,
                isLocked: false,
                sortOrder: null,
                tags: null,
                dateToPublishLive: new Date(),
                displayOnHomeScreen: false,
                sessions: [],
                lockedByCoupon: null
            },
            genres: [],
            tempContent: null,
            contentPageImage: [],
            homePageImage: [],
            menuImage: [],
            selectedInterests: [],
            menuListNumbers: [],
            coupons: []
        }
    },
    computed: {
        availableInterests() {
            if (!this.selectedGenre) return []
            return this.selectedGenre.interests
        },
        selectedGenre() {
            if (!this.genres || !this.details.genre) return null

            return this.genres.first((x) => x.id == this.details.genre.id)
        }
    },
    methods: {
        async saveContent() {
            this.loading = true
            if (await this.validate()) {
                try {
                    var response

                    this.details.interests = []

                    this.selectedInterests.forEach((i) => {
                        this.details.interests.push({ id: i })
                    })

                    if (this.details.id) {
                        //update
                        response = await this.$api.playlist.updatePlaylist(this.details)
                        await this.saveContentPageImage(response.id)
                        await this.saveHomePageImage(response.id)
                        await this.saveMenuImage(response.id)

                        this.notifySuccess(
                            'Updated successfully',
                            'Content Updated successfully.',
                            5000
                        )
                        this.$emit('input', this.details)
                        this.globalEmit('updated-player')
                    } else {
                        //create
                        response = await this.$api.playlist.createPlaylist(this.details)
                        this.details.id = response.id
                        await this.saveContentPageImage(response.id)
                        await this.saveHomePageImage(response.id)
                        await this.saveMenuImage(response.id)

                        this.notifySuccess(
                            'Created successfully',
                            'Content created successfully.',
                            5000
                        )
                        this.$router.replace(`/players/${response.id}`)
                        this.globalEmit('updated-player')
                    }
                } catch (err) {
                    console.error(err)

                    this.notifyError('Error', `Error message: ${err}`, 5000)
                } finally {
                    this.loading = false
                }
            }
            this.loading = false
        },
        setContentPageImage(newImage) {
            this.$set(this.contentPageImage, 0, newImage)
        },
        async saveContentPageImage(id) {
            if (this.contentPageImage.any() && this.contentPageImage[0].file) {
                await this.$api.playlist.updateContentPageImage(id, this.contentPageImage[0])
                this.setContentPageImage({ ...this.contentPageImage[0], file: null })
            }
        },
        setHomePageImage(newImage) {
            this.$set(this.homePageImage, 0, newImage)
        },
        async saveHomePageImage(id) {
            if (this.homePageImage.any() && this.homePageImage[0].file) {
                await this.$api.playlist.updateHomePageImage(id, this.homePageImage[0])
                this.setHomePageImage({ ...this.homePageImage[0], file: null })
            }
        },
        setMenuImage(newImage) {
            this.$set(this.menuImage, 0, newImage)
        },
        async saveMenuImage(id) {
            if (this.menuImage.any() && this.menuImage[0].file) {
                await this.$api.playlist.updateMenuImage(id, this.menuImage[0])
                this.setMenuImage({ ...this.menuImage[0], file: null })
            }
        },
        async fetchGenreListNumbers() {
            var list = await this.$api.genre.fetchGenreListNumbers(this.details.genre.id)
            this.menuListNumbers = list.sort((a, b) => a - b)
        }
    },

    async mounted() {
        var genreResponse = await this.$api.genre.fetchGenres({ pageSize: 500 })
        this.genres = genreResponse.data

        var interestResponse = await this.$api.interest.fetchInterests()
        this.interests = interestResponse.data

        var couponsResponse = await this.$api.coupon.fetchCoupons({ pageSize: 500 })
        this.coupons = couponsResponse.data

        if (this.details.genre) {
            this.details.genre = this.genres.find((g) => g.id == this.details.genre.id)
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');

.card-background {
    background: transparent;
    height: 100%;
}
.custom-height {
    min-height: 540px;
}
.create {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
    letter-spacing: 2px;
}
a {
    font-size: 1rem;
}
p {
    color: #949c9c;
}
li {
    color: #949c9c;
    font-size: 1.1rem;
}

#beginner,
#intermediate,
#advanced {
    display: inline-block;
    height: 100%;
    width: calc(100% / 3);
    margin: 0;
    padding: 0;
    font-size: 0.85rem;
}

.twoColumnSplit {
    display: inline-block;
    height: 100%;
    width: calc(100% / 2);
    margin: 0;
    padding: 0;
    font-size: 0.85rem;
}

#intermediate {
    text-align: center;
}

#advanced {
    text-align: right;
}

.imageUploaderText {
    font-size: 0.85rem;
}
</style>
